import React from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import logo from '../assets/logo.svg';

const Logo = styled('img')({
  height: '40px',
  marginRight: '16px',
});

const Header = () => {
  return (
    <AppBar position="static" sx={{ mb: 3 }}>
      <Toolbar>
        <Logo src={logo} alt="Company Logo" />
      </Toolbar>
    </AppBar>
  );
};

export default Header; 